// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge[data-v-e47a9018] {\n  background: var(--magic-secondary, #ffd20c);\n  color: var(--magic-dark, #000);\n}", ""]);
// Exports
module.exports = exports;
